import React from 'react';
import ReactDOM from 'react-dom/client';
import { TonConnectUIProvider } from '@tonconnect/ui-react';
import './index.css';
import App from './App';
import TelegramOnly from './components/TelegramOnly';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Disable StrictMode to prevent double mounting and duplicate operations
// which can cause performance issues in Telegram WebApp
root.render(
  <TonConnectUIProvider
    manifestUrl={window.location.origin + '/tonconnect-manifest.json'}
  >
    <TelegramOnly>
      <App />
    </TelegramOnly>
  </TonConnectUIProvider>
);
